export enum EnumLang {
  ca = "ca",
  es = "es",
  en = "en",
  oc = "oc",
}

export type LangString = keyof typeof EnumLang;
